import { Snackbar } from '@material-ui/core';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Redirect, Switch } from 'react-router-dom';
import ErrorPage from './pages/404/ErrorPage';
import { Registration } from './pages/register/Registration';
import PublicRoute from './routes/PublicRoute';
import { alertActions } from './_actions/alert.actions';
import { AlertActionTypes, AlertTypes } from './_types/alert.types';
import logo from './assets/traverse-header.svg';
import detailedLogo from './assets/traverse-detailed-logo.svg';
import './App.css';
import { BasicInfo } from './pages/register/BasicInfo';
import { Registered } from './pages/register/Registered';
import { EmailValidation } from './pages/register/EmailValidation';

const Alert = (props: AlertProps) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

type Props = {
  alert: AlertActionTypes
}

type AlertSeverityTypes = "success" | "info" | "warning" | "error" | undefined;

const App = (props: Props) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (props.alert.message) {
      setOpen(true);
    }
  }, [props.alert])

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const getAlertType = (alert: AlertActionTypes): AlertSeverityTypes => {
    if (alert.type === AlertTypes.SUCCESS) {
      return "success";
    } else if (alert.type === AlertTypes.ERROR) {
      return "error";
    }
  }

  return (
    <Fragment>
      {
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity={getAlertType(props.alert)}>
            {props.alert.message}
          </Alert>
        </Snackbar>}

      <header className="AppHeader">
        <div className="AppHeaderLogo">
          <img className="AppHeaderLogo" src={logo} alt="Traverse" />
        </div>
        <div className="AppHeaderPrompt">
          {/* <span className="AppHeaderPromptDetail">Already have an account?</span> &nbsp; <span className="AppHeaderLink">Sign In</span> */}
        </div>
      </header>

      <div className="AppContentContainer">
          <BrowserRouter>
            <Switch>
              <PublicRoute exact path='/' component={Registration}></PublicRoute>
              <PublicRoute exact path='/register' component={BasicInfo}></PublicRoute>
              <PublicRoute exact path='/submitted' component={EmailValidation}></PublicRoute>
              <PublicRoute exact path='/verify' component={Registered}></PublicRoute>
              <PublicRoute path='/404' component={ErrorPage}></PublicRoute>
              <Redirect from='*' to='/404' />
            </Switch>
          </BrowserRouter>

        <footer className="AppFooter">
          <div className="AppFooterDetails">
            <img src={detailedLogo} alt="Traverse Employee Care" />
            <div className="AppFooterDetailHeader">
              <div className="AppFooterDetailTitle">Learn More</div>
              <div className="AppFooterDetailLink" onClick={() => {window.open('https://traversecare.com')}}>About Traverse Employee Care</div>
              <div className="AppFooterDetailLink" onClick={() => {window.open('https://traversecare.com/software.html')}}>Traverse Covid Management Software</div>
              <div className="AppFooterDetailLink" onClick={() => {window.open('https://complyservices.com')}}>Compliance Services</div>
            </div>
            {/* <div className="AppFooterDetailHeader">
              <div className="AppFooterDetailTitle">Legal</div>
              <div className="AppFooterDetailLink">Traverse Terms of Service</div>
              <div className="AppFooterDetailLink">Privacy Policy</div>
              <div className="AppFooterDetailLink">&nbsp;</div>
            </div> */}
          </div>
          <div className="AppFooterCopyright">
            ©️ 2021 Compliance Services, LLC | Traverse is a registered trademark of Compliance Services.
          </div>
        </footer>
      </div>
    </Fragment>

  );
}

function mapState(state: any) {
  const { alert } = state;
  return { alert: alert };
}

const actionCreators = {
  clearAlerts: alertActions.clear
}

const connectedApp = connect(mapState, actionCreators)(App);

export default connectedApp;
